import { ApolloProvider } from '@apollo/client';
import { ReactNode, useEffect, useState } from 'react';

import { graphqlClient } from '../../graphql';
import { Firebase } from '../../services';

interface Props {
  children: ReactNode;
}

const Initializer = ({ children }: Props) => {
  const [isInitialized, setInitialized] = useState(false);

  useEffect(() => {
    Firebase.config.auth.onAuthStateChanged((user) => {
      if (user) {
        localStorage.setItem('isAuthenticated', 'true');
      } else {
        localStorage.removeItem('isAuthenticated');
      }
      setInitialized(true);
    });
  }, []);

  if (!isInitialized) return null;

  return <ApolloProvider client={graphqlClient}>{children}</ApolloProvider>;
};

Initializer.displayName = 'Initializer';

export default Initializer;
